import { ProductCardViewData } from '@services/MarppleShop/features/ProductList/type';
import { html, ListView, View } from 'rune-ts';
import klass from '@services/MarppleShop/renderApp/pages/RecentlySold/RecentlySold.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { CardProductControllerView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductControllerView.ts';
import { getSharedData } from '@services/MarppleShop/shared/util/rune.ts';

export type TProductCardViewDataWithIsNew = ProductCardViewData & {
  isNew: boolean;
};

class CardProductControllerItemView extends View<TProductCardViewDataWithIsNew> {
  protected override async onMount() {
    if (this.data.isNew) {
      void this.element().offsetWidth; // Trigger reflow
      requestAnimationFrame(() => this.element().classList.add(klass.fade_in));
    }
  }

  protected override template(props: TProductCardViewDataWithIsNew) {
    const sharedData = getSharedData(this);

    return html`<li class="${classes(klass.card_product_controller_item, { [klass.hide]: props.isNew })}">
      ${new CardProductControllerView({
        card_product_view_props: {
          type: 'B',
          size: sharedData.is_mobile ? 'Medium' : 'Large',
          layout: 'Vertical',
          theme: 'Light',
        },
        product_card_view_data: props,
        options: {
          resize_width: 600,
        },
      })}
    </li>`;
  }
}

export class CardProductControllerListView extends ListView<CardProductControllerItemView> {
  override tagName = 'ul';
  override ItemView = CardProductControllerItemView;
}
